'use client';

import { AppleLoginButton } from '@/features/auth/login/apple/components/AppleLoginButton';
import { useSocialLogin } from '@/features/auth/login/hooks/useSocialLogin';
import { LineLoginButton } from '@/features/auth/login/line/components/LineLoginButton';
import { useLastLoginProviderStorage } from '@/shared/hooks/useLastLoginProviderStorage';
import { useTopProgress } from '@/shared/hooks/useTopProgress';
import { LoginProviderEnum } from '@gorgeous/common/enums/users/login-provider.enum';
import Image from 'next/image';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

export const LoginButtonsContainer = () => {
  const searchParams = useSearchParams();
  const redirectUri = searchParams?.get('redirect_uri');
  const { lastLoginProvider } = useLastLoginProviderStorage();
  const { loginWithLine, loginWithApple, pendingLoginProvider, isLoginPending } = useSocialLogin();
  useTopProgress(isLoginPending);

  // 電話番号ログインへのリンクURLを生成
  const phoneLoginHref = redirectUri ? `/login/phone?redirect_uri=${encodeURIComponent(redirectUri)}` : '/login/phone';

  return (
    <>
      <LineLoginButton
        showLastLogin={lastLoginProvider === LoginProviderEnum.Line}
        onLogin={loginWithLine}
        disabled={isLoginPending}
        isLoginPending={pendingLoginProvider === 'line'}
      />
      <AppleLoginButton
        showLastLogin={lastLoginProvider === LoginProviderEnum.Apple}
        onLogin={loginWithApple}
        disabled={isLoginPending}
        isLoginPending={pendingLoginProvider === 'apple'}
      />
      <Link
        href={phoneLoginHref}
        aria-disabled={isLoginPending}
        tabIndex={isLoginPending ? -1 : undefined}
        onClick={(event) => {
          if (isLoginPending) event.preventDefault();
        }}
        className={`flex items-center relative w-full px-6 py-4 bg-primary text-white rounded-[6px] transition-opacity ${
          isLoginPending ? 'cursor-not-allowed opacity-50' : 'hover:opacity-90'
        }`}
      >
        <div className="absolute left-6 w-6 h-6">
          <Image src="/icons/phone-icon.svg" alt="電話" width={24} height={24} className="w-full h-full object-contain" />
        </div>
        <div className="flex flex-col items-center w-full">
          <span className="text-[16px] font-semibold">電話番号で続ける</span>
          {lastLoginProvider === LoginProviderEnum.Phone && <span className="text-[12px] font-semibold leading-[13px]">前回ログイン</span>}
        </div>
      </Link>
    </>
  );
};
